module.exports = __webpack_public_path__ + "dcb02ba70f02d146bcc492bc0cad1fd1.pdf";